import { AfterViewChecked, Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
    selector: '[routerLinkActiveParent]',
    standalone: false
})
export class RouterLinkActiveParentDirective implements AfterViewChecked {
  @Input() routerLinkActiveParent: string;

  constructor(
    private el: ElementRef, private renderer: Renderer2
  ) {
  }

  ngAfterViewChecked(): void {
    // find inserted class
    const firstChild = this.el.nativeElement.firstChild;
    if (firstChild && firstChild.classList?.contains('active-link')) {
      // add 'active' class to parent element
      this.renderer.addClass(this.el.nativeElement.parentNode, `${this.routerLinkActiveParent}__active`);
      return;
    } else {
      this.renderer.removeClass(this.el.nativeElement.parentNode, `${this.routerLinkActiveParent}__active`);
    }
    // find inserted class
    const parent = this.el.nativeElement.parentNode;
    if (parent.tagName.toLowerCase() === 'a' && parent.classList?.contains('active-link')) {
      // add 'active' class to parent element
      this.renderer.addClass(this.el.nativeElement.parentNode, `${this.routerLinkActiveParent}__active`);
    } else {
      this.renderer.removeClass(this.el.nativeElement.parentNode, `${this.routerLinkActiveParent}__active`);
    }
  }
}
